import styled from 'styled-components';
import { Tooltip } from 'antd';
import { FormikContextType } from 'formik';

import { Constants } from 'core';
import { SendCommunicationFirstStepForm } from 'types';

export const OUIGO_FIRST_NUMBER_CARRIAGES = Constants.TRAIN_CONFIGURATION.OUIGO.FIRST_TRAIN.length;
export const OUIGO_ES_FIRST_NUMBER_CARRIAGES = Constants.TRAIN_CONFIGURATION.OUIGO_ESP.FIRST_TRAIN.length;
export const OUIGO_LC_NUMBER_CARRIAGES = Constants.TRAIN_CONFIGURATION.OUIGO_LC.length;
export const OUIGO_LB_NUMBER_CARRIAGES = Constants.TRAIN_CONFIGURATION.OUIGO_LB.length;

export const getNumberCarriages = (selectedServiceType: string) => {
  let numberCarriagesInFirstTrain = OUIGO_FIRST_NUMBER_CARRIAGES;
  switch (selectedServiceType) {
    case 'OUIGO_ES':
      numberCarriagesInFirstTrain = OUIGO_ES_FIRST_NUMBER_CARRIAGES;
      break;
    case 'OUIGO_LC':
      numberCarriagesInFirstTrain = OUIGO_LC_NUMBER_CARRIAGES;
      break;
    case 'OUIGO_LB':
      numberCarriagesInFirstTrain = OUIGO_LB_NUMBER_CARRIAGES;
      break;
    case 'OUIGO':
    default:
      numberCarriagesInFirstTrain = OUIGO_FIRST_NUMBER_CARRIAGES;
      break;
  }
  return numberCarriagesInFirstTrain;
};

export type Props = {
  formik: FormikContextType<SendCommunicationFirstStepForm>;
  onTouch: () => void;
  selectedServiceType?: string | undefined;
  equipementCarriages: number[] | null | undefined;
  isVisible: boolean;
};

export const Container = styled.div<{ isVisible: boolean }>`
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  ${({ isVisible }) => !isVisible && 'height: 0'};
  overflow: hidden;
  transform: translateY(${({ isVisible }) => (isVisible ? '0' : '-20px')});
  transition: opacity 0.8s, transform 0.5s;
`;
export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 0.625rem;
`;

export const StyledTooltip = styled(Tooltip)`
  margin-left: 50px;
  align-items: center;
`;
